export default{
    lista:{
        method:'get',
        url:'vale/alimentacao/trabalhador/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'vale/alimentacao/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'vale/alimentacao/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'vale/alimentacao/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'vale/alimentacao/trabalhador/update'
    }
}